import { useMutation } from '@tanstack/react-query';
import { request } from '../services/request';

export const useOrganiaationMutation = () => {
    return useMutation(async (data: any) => {
        const jsonResponse = await request({
            data,
            method: 'PUT',
            endpoint: 'org/update',
        });

        if (!jsonResponse.success) {
            throw new Error(jsonResponse.data.Message || 'Something went wrong');
        }
        return jsonResponse;
    });
};


